// extracted by mini-css-extract-plugin
export default {"wrap":"wrap---udiGi","centered":"centered---vIuoa"};